import { hasToken } from 'utils/auth'
import { FlowRoute } from 'utils/FlowProvider/types'
import { getVisitedPages } from 'utils/FlowProvider/utils'

const referrersRegex = env => [
  new RegExp(new URL(env.get('loginUrl')).host),
  /^[a-f0-9]{7}.signin.staging.acorns.io$/,
  /^[a-f0-9]{7}.signin.dev.acorns.io$/,
  /^[a-f0-9]{7}.signin.acorns.com$/,
  new RegExp(new URL(env.get('webAppUrl')).host),
  /^[a-f0-9]{7}.app.staging.acorns.io$/,
  /^[a-f0-9]{7}.app.dev.acorns.io$/,
  /^[a-f0-9]{7}.app.acorns.com$/,
]

export const didLogin = (referrerUrl, env) => {
  const referrerHost = referrerUrl ? new URL(referrerUrl).host : ''

  return referrersRegex(env).some(exp => exp.test(referrerHost)) || hasToken()
}

export const hasSignedIn = (visitedPages = []) => {
  return (
    visitedPages.find(page => page !== FlowRoute.Signup && page !== FlowRoute.Welcome) !== undefined
  )
}

export const isNewTab = () => {
  return document.referrer === '' && hasSignedIn(getVisitedPages()) && history.length === 2
}
